<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface"></ParseForm>
      </template>
      <template>
        <ParseList ref="addr" :formId="formItems.addr.formId" :formParams="formItems.addr.formObj" :Title="formItems.addr.title" :opCode="opCode" 
          :funcClick="bindClickOnAddrList" :maxLength="formItems.addr.maxLength" :minLength="formItems.addr.minLength" >
        </ParseList>
      </template>
      <UsersubProfileList ref='profileList' :getCheckedDatas='getCheckedList' ></UsersubProfileList>
      <DnnProfileList ref='dnnProfileList' :getCheckedDatas='getDnnCheckedList' ></DnnProfileList>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import UsersubProfileList from "./UsersubProfileList";
import DnnProfileList from "./DnnProfileList";
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ParseList from '../../../util/parseFormNew/ParseList';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "AddUserForm",
  components: {
    ParseForm,
    UsersubProfileList,
    DnnProfileList,
    ParseList,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.addr) {
        if (!this.$refs.addr.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const addr = this.$refs.addr.getDatas();
        if (addr) {
          map.set('dnnStaticAddrs', addr.list);
        }        
      }
      console.log(map);
      return map;
    },
    UpdateAddrConfig(json) {
      return json.map((item)=>{
        if (item.id === "dnnStaticAddrs") {
          return {
            ...item,
            "attrList": [
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"count",
                "couldMod":false,
                "showName":"addr个数",
                "hidden":true,
                "name":"count",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "couldBatchMod":false
              },
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"list",
                "couldMod":false,
                "showName":"addr",
                "hidden":true,
                "name":"list",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "attrList":	item.attrList,
                "couldBatchMod":false
              }
            ]
          }
        }
        else {
          return item;
        }
      })
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.udmJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const jsonObj = this.UpdateAddrConfig(response.data.resultVal);
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(jsonObj, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        this.formItems.addr.formObj = resultMap.get(this.formItems.addr.modelName); 
        callback(response);
      }); 
    }, 
    saveUser(ne, callback) {
      const formData = this.getDatas();      
      if (formData) { 
        const dnnStaticAddrs = formData.get("dnnStaticAddrs");
        const params = { 
          vo: {
            "neid": ne.neid,
            "supi": formData.get("supi"),
            "gpsi": formData.get("gpsi"),
            "k": formData.get("k"),
            "amf": formData.get("amf"),
            "op": formData.get("op"),
            "userSubProfileId": formData.get("userSubProfileId"),
            "dnnStaticAddrs": dnnStaticAddrs,
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
    getCheckedList(list) {
      this.$refs.basic.setData('userSubProfileId', list[0] || '');
      this.profileId = list[0] || ''; 
    },
    getDnnCheckedList(list) {
      this.$refs.addr.setData(this.$refs.addr.getClickIndex(), 'dnnProfileId', list[0].dnnProfileId || ''); 
    },
    onclickProfileId() {
      this.$refs.profileList.qryList(this.ne);
      this.$refs.profileList.show();
    },
    onclickPdnProfileId() {
      this.$refs.dnnProfileList.qryList(this.ne, this.profileId);
      this.$refs.dnnProfileList.show();     
    }, 
  },
  computed: {
    bindClickOnAddrList() {
      this.funcMap2 = new Map();      
      this.funcMap2.set('dnnProfileId', () => { this.onclickPdnProfileId(); });
      return this.funcMap2;
    },
    bindClickInterface() { 
      this.funcMap1 = new Map();      
      this.funcMap1.set('userSubProfileId', () => { this.onclickProfileId(); });
      return this.funcMap1;
    }
  },
  data() {
    return {
      ne: null, 
      profileId: '',
      funcMap1: null,
      funcMap2: null,
      formItems: {
        basic: {
          formId: "SupiAddBasicInfo",
          modelName: "basic",
          formObj: null,
        },
        addr: {
          title: this.$t("LteUser.staticAddr"),
          formId: "SupiAddStaticAddrInfo",
          modelName: "addr", 
          formObj: null,
          maxLength: 5,
          minLength: 1,
        },
      }, 
      opCode: "add",
      msgId: "28692",
    };
  },
  beforeDestroy() {
  }
};
</script>
